import { PenLine, Receipt } from "lucide-react";

/**
 * Two-segment Estimate / Actual toggle for the dashboard header.
 * Purely visual state — parent owns the `mode` value.
 */
export default function ModeToggle({ mode, onChange }) {
  const segments = [
    { value: "estimate", label: "Estimate", Icon: PenLine },
    { value: "actual",   label: "Actual",   Icon: Receipt },
  ];
  return (
    <div
      className="inline-flex items-center bg-white border border-black/[0.08] rounded-lg p-0.5"
      data-testid="mode-toggle"
      role="tablist"
    >
      {segments.map(({ value, label, Icon }) => {
        const active = mode === value;
        return (
          <button
            key={value}
            type="button"
            role="tab"
            aria-selected={active}
            data-testid={`mode-${value}`}
            onClick={() => onChange(value)}
            className={`h-7 px-2.5 rounded-md text-xs font-medium inline-flex items-center gap-1.5 transition-all ${
              active
                ? value === "actual"
                  ? "bg-slate-brand-200 text-slate-brand-700 border border-slate-brand-300"
                  : "bg-sage-200 text-sage-700 border border-sage-300"
                : "text-[#78716C] hover:text-[#1C1C1C]"
            }`}
          >
            <Icon className="w-3 h-3" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
